export { SkeletonPage } from "./SkeletonPage";
export { SkeletonTable } from "./SkeletonTable";
export { SkeletonTabs } from "./SkeletonTabs";
